'use client';

import { T } from '@/i18n/LocaleProvider';
import { MONO_FONT } from '@/theme';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function SectionHeader({
  eyebrow,
  title,
  subtitle,
  dark = false,
  align = 'left',
  sx = {},
}) {
  const isCenter = align === 'center';

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: isCenter ? '1fr' : { xs: '1fr', md: '1fr 1fr' },
        gap: { xs: 3, md: 6 },
        textAlign: isCenter ? 'center' : 'left',
        mb: { xs: 6, md: 8 },
        ...sx,
      }}
    >
      {(eyebrow || title) && (
        <Box>
          {eyebrow && (
            <Box
              component="span"
              sx={{
                fontFamily: MONO_FONT,
                fontSize: '11px',
                fontWeight: 500,
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'text.accent',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '12px',
                mb: 3,
                '&::before': {
                  content: '""',
                  width: '24px',
                  height: '1px',
                  background: 'currentColor',
                  flexShrink: 0,
                },
              }}
            >
              <T>{eyebrow}</T>
            </Box>
          )}
          {title && (
            <Typography
              variant="h2"
              component="h2"
              sx={{ color: dark ? 'common.white' : 'text.primary' }}
            >
              <T>{title}</T>
            </Typography>
          )}
        </Box>
      )}
      {subtitle && (
        <Typography
          sx={{
            fontSize: 'clamp(17px, 1.5vw, 21px)',
            lineHeight: 1.6,
            color: dark ? 'text.muted' : 'grey.600',
            alignSelf: 'end',
          }}
        >
          <T>{subtitle}</T>
        </Typography>
      )}
    </Box>
  );
}
